import {ChangeDetectionStrategy, Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'spt-success-message',
  templateUrl: './success-message.component.html',
  styleUrls: ['./success-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SuccessMessageComponent {
  @Output() dismiss: EventEmitter<boolean> = new EventEmitter();
}
